import { put, takeEvery, call } from '@redux-saga/core/effects';
import {
  get_sellers_success,
  get_sellers_error,
  get_sellers,
  get_products,
  get_products_success,
  get_products_error,
  get_sellers_locations,
  get_sellers_locations_error,
  get_sellers_locations_success,
  get_partner_id,
  get_partner_id_success,
  get_partner_id_error,
  get_categories,
  get_categories_success,
  get_categories_error,
} from './reducer';
import api from '@service/DataService';
import toast from 'react-hot-toast';

function* getSellersSaga({ payload }) {
  try {
    const requestRes = yield call(api.get, `/partners/${payload}`);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_sellers_success.type,
      payload: response,
    });

    if (window.location.pathname !== '/marketplace') {
      localStorage.setItem('seller_name', response.business_name);
    }
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_sellers_error.type,
    });
  }
}
function* getSellersDeliveryLocationSaga({ payload }) {
  try {
    const requestRes = yield call(
      api.get,
      `/delivery_locations/bypartner/${payload}`,
    );
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_sellers_locations_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_sellers_locations_error.type,
    });
  }
}
function* getSellersProductsSaga({ payload }) {
  try {
    const {
      page = 1,
      limit = 20,
      id,
      debounced,
      filter,
      lowPrice,
      highPrice,
    } = payload;
    let search = ``;
    if (debounced) {
      search = `&search=${debounced}`;
    }

    let category = ``;
    if (filter) {
      category = `&product_category=${filter}`;
    }

    let low_price = ``;
    if (lowPrice) {
      low_price = `&low_price=${lowPrice}`;
    }
    let high_price = ``;
    if (highPrice) {
      high_price = `&high_price=${highPrice}`;
    }
    const requestRes = yield call(
      api.get,
      `/products/bypartner/${id}?&page=${page}&limit=${limit}${search}${category}${low_price}${high_price}`,
    );
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_products_success.type,
      payload: response,
    });
  } catch (error) {
    yield put({
      type: get_products_error.type,
    });
  }
}

function* getSellersIdSaga({ payload }) {
  try {
    const request = yield call(api.get, `/partners?name=${payload}`);
    const response = request.data;
    const res = response.data;
    yield put({
      type: get_partner_id_success.type,
      payload: res,
    });
    localStorage.setItem('partner_id', res?.partners[0]?._id);
  } catch (error) {
    console.log(error);
    yield put({
      type: get_partner_id_error.type,
    });
  }
}

function* getCategories({ payload }) {
  try {
    const request = yield call(api.get, `/product_categories?partner=${payload}`);
    const responseData = request.data;
    const response = responseData.data;
    yield put({
      type: get_categories_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_categories_error.type,
    });
  }
}

function* sellersSagas() {
  yield takeEvery(get_sellers.type, getSellersSaga);
  yield takeEvery(get_products.type, getSellersProductsSaga);
  yield takeEvery(get_sellers_locations.type, getSellersDeliveryLocationSaga);
  yield takeEvery(get_partner_id.type, getSellersIdSaga);
  yield takeEvery(get_categories.type, getCategories);
}

export default sellersSagas;
